export default "__VITE_ASSET__WUDW67Sj__"